import { render, staticRenderFns } from "./creation.vue?vue&type=template&id=6b244ba0&"
import script from "./creation.vue?vue&type=script&lang=js&"
export * from "./creation.vue?vue&type=script&lang=js&"
import style0 from "./creation.vue?vue&type=style&index=0&id=6b244ba0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports